<template>
  <div>
    <quill-editor
      :options="editorOption"
      @blur="onEditorBlur($event)"
      @change="onEditorChange($event)"
      @focus="onEditorFocus($event)"
      class="ql-editor"
      :style="'min-height:'+minHeight+'px'"
      ref="myQuillEditor"
      v-model="currentValue"
    ></quill-editor>
    <Modal title="视频上传" v-model="showVideo" width="50vw">
      <Form :label-width="120" :model="videoFrom" :rules="videoFromValidate" ref="videoFrom">
        <FormItem label="视频上传类型" prop="type">
          <RadioGroup
            @on-change="(val) => {this.videoFrom.fullUrl = ''; this.files = []}"
            v-model="videoFrom.type"
          >
            <Radio :label="'local'">本地上传</Radio>
            <Radio :label="'url'">URL地址</Radio>
          </RadioGroup>
        </FormItem>
        <template v-if="videoFrom.type && showVideo">
          <FormItem label="本地视频上传" prop="fullUrl" v-if="videoFrom.type == 'local'">
            <agilityFileUpload :opts="fileOpts" @uploadFile="uploadVFile" v-if="files.length <= 0">
              <template slot="uploadContent">
                <div style="padding: 20px 0">
                  <Icon size="52" style="color: #3399ff" type="ios-cloud-upload"></Icon>
                  <p>点击或拖拽文件到此处</p>
                </div>
              </template>
            </agilityFileUpload>
            <template v-else>
              <Input clearable v-model="videoFrom.fullUrl"></Input>
            </template>
          </FormItem>
          <FormItem label="视频地址" prop="fullUrl" v-if="videoFrom.type == 'url'">
            <Input clearable v-model="videoFrom.fullUrl"></Input>
          </FormItem>
        </template>
      </Form>
      <div slot="footer">
        <Button @click="canceShowVideo" ghost type="primary">取消</Button>
        <Button @click="saveShowVideo" type="primary">确定</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import { quillEditor, Quill } from 'vue-quill-editor' //引入插件
import { addQuillTitle } from './agility-editor/quill-title.js'

import { ImageDrop } from 'quill-image-drop-module'
import ImageResize from "quill-image-resize-module"
Quill.register("modules/imageResize", ImageResize)
import { container, ImageExtend, QuillWatch } from 'quill-image-extend-module'
Quill.register('modules/ImageExtend', ImageExtend)
Quill.register('modules/imageDrop', ImageDrop)

export default {
  name: "agilityEditor",
  components: {
    quillEditor
  },
  props: {
    /* 编辑器的内容 */
    value: {
      type: String,
      default: "",
    },
    minHeight: {
      type: Number,
      default: 350,
    },
    editorOptionToolbar: {
      required: false,
      default: () => {
        return {}
      }
    },
  },
  data () {
    let _self = this
    return {
      showVideo: false,
      fileOpts: {
        multiple: false,
        accept: 'video/*',
        format: ['mp4', 'avi', 'wmv', 'mpg', 'mpeg', 'mov', 'flv', 'swf', 'mkv', 'rmvb'],
        showUploadList: false,
        defauleFiles: [],
        data: {},
      },
      currentValue: "",

      videoFrom: {
        type: '',
        fullUrl: ''
      },
      videoFromValidate: {
        type: [{ required: true, message: '请选择上传地址', trigger: "change" }],
        fullUrl: [{ required: true, message: '请上传视频', trigger: "blur" }],
      },
      files: [],
      defaultToolbar: {
        container: [
          ["bold", "italic", "underline", "strike"], // 加粗 斜体 下划线 删除线
          ["blockquote", "code-block"], // 引用  代码块
          [{ list: "ordered" }, { list: "bullet" }], // 有序、无序列表
          [{ indent: "-1" }, { indent: "+1" }], // 缩进
          // [{ size: [] }], // 字体大小
          [{ font: [] }], // 字体大小
          [{ header: [1, 2, 3, 4, 5, 6, false] }], // 标题
          [{ color: [] }, { background: [] }], // 字体颜色、字体背景颜色
          [{ align: [] }], // 对齐方式
          ["clean", "link", "image", "video"], //清除文本格式 链接、图片、视频
        ],
        handlers: {
          'video': function (value) {
            console.log('video', value)
            _self.showVideo = true
          }
        }
      }
    }
  },
  computed: {
    editorOption: function () {
      let toolbar = Object.assign({}, this.defaultToolbar, this.editorOptionToolbar)
      console.log('toolbar', toolbar)
      return {
        theme: "snow",
        bounds: document.body,
        debug: "warn",
        modules: {
          history: {
            delay: 1000,
            maxStack: 50,
            userOnly: false
          },
          toolbar: toolbar,
          // 图片拖拽上传
          imageDrop: true,
          // 放大缩小
          imageResize: {
            displaySize: true
          },
        },
        placeholder: "请输入正文",
      }
    }
  },
  watch: {
    value: {
      handler (val) {
        if (val != this.currentValue) {
          this.currentValue = val
        }
      },
      immediate: true,
    },
  },
  methods: {
    canceShowVideo: function () {
      this.videoFrom = {
        type: '',
        baseUrl: '',
        protocol: 'http',
      }
      this.$refs.videoFrom.resetFields()
    },
    saveShowVideo: function () {
      let that = this
      this.$refs["videoFrom"].validate(valid => {
        if (valid) {
          console.log('validate videoFrom success', this.videoFrom)
          this.showVideo = false
          let quill = this.$refs['myQuillEditor'].quill
          // 获取富文本
          let range = quill.getSelection()
          // 获取光标位置：当编辑器中没有输入文本时，这里获取到的 range 为 null
          let index = range ? range.index : 0
          // 在光标所在位置 插入视频
          quill.insertEmbed(index, 'video', that.videoFrom.fullUrl)
          // 调整光标到最后
          quill.setSelection(index + 1)
        } else {
          return false
        }
      })
    },
    uploadVFile: function (data) {
      if (data.length > 0) {
        this.videoFrom.fullUrl = data[0].url
      } else {
        this.videoFrom.fullUrl = ''
      }
      this.files = data
    },
    // 事件方法
    onEditorBlur (e) {
      console.log('失去焦点事件', e)
    },
    onEditorFocus (e) {
      console.log('获得焦点事件', e)
    },
    onEditorChange (e) {
      console.log('内容改变事件', e)
      this.$emit("on-change", e.html)
    },
  },
  mounted () {
    this.currentValue = this.value || ''
    addQuillTitle()
  }
};
</script>

<style lang="less">
.ql-editor {
  padding: 0;
  min-height: 200px;
  display: flex;
  flex-direction: column;

  .ql-container {
    flex-grow: 1;
  }
}
// 汉化
.ql-snow .ql-tooltip::before {
  content: '访问地址';
}
.ql-snow .ql-tooltip a.ql-action::after {
  content: '编辑';
}
.ql-snow .ql-tooltip a.ql-remove::before {
  content: '移除';
}
.ql-snow .ql-tooltip[data-mode='link']::before {
  content: '输入地址';
}
.ql-snow .ql-tooltip.ql-editing a.ql-action::after {
  content: '保存';
}

.ql-snow .ql-picker.ql-header .ql-picker-label::before,
.ql-snow .ql-picker.ql-header .ql-picker-item::before {
  content: '文本';
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value='1']::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value='1']::before {
  content: '标题1';
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value='2']::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value='2']::before {
  content: '标题2';
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value='3']::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value='3']::before {
  content: '标题3';
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value='4']::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value='4']::before {
  content: '标题4';
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value='5']::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value='5']::before {
  content: '标题5';
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value='6']::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value='6']::before {
  content: '标题6';
}

.ql-snow .ql-picker.ql-font .ql-picker-label::before,
.ql-snow .ql-picker.ql-font .ql-picker-item::before {
  content: '标准字体';
}
.ql-snow .ql-picker.ql-font .ql-picker-label[data-value='serif']::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value='serif']::before {
  content: '衬线字体';
}
.ql-snow .ql-picker.ql-font .ql-picker-label[data-value='monospace']::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value='monospace']::before {
  content: '等宽字体';
}
</style>
